import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export const haptics = {
  /**
   * Light impact - for subtle feedback (tab changes, toggles)
   */
  light: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Light });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Medium impact - for standard interactions (likes, bookmarks)
   */
  medium: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Medium });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Heavy impact - for significant actions
   */
  heavy: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Heavy });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Success notification - for completed actions (post sent, message delivered)
   */
  success: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Success });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Warning notification - for caution states
   */
  warning: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Warning });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Error notification - for error states
   */
  error: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Error });
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },

  /**
   * Selection changed - for picker/selection changes
   */
  selection: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.selectionChanged();
      } catch (e) {
        // Silently fail if haptics not available
      }
    }
  },
};
